<template lang="html">
    <div></div>
</template>

<script>
export default {
    name: "404",
    created() {
        this.$router.push("/");
    },
};
</script>

<style lang="less"></style>
